module.exports = __webpack_public_path__ + "static/grow-782817a95fc2d1d582752c8e902c6920.svg";